module.exports = [
	/**
	 * Components
	 */
	{
		title: "Components",
		icon: {
			name: "at-plugin",
		},
		entryCardText: "Find all currently available components here",
		path: "components",
		redirect: "components",
		appFolder: "ComponentsDocumentation",
		routes: [
			{
				title: "Overview",
				path: "components",
				rootPath: "/components/components",
				componentPath: "components/Components",
			},
			{
				title: "Accordion",
				path: "accordion",
				rootPath: "/components/accordion",
				componentPath: "components/Accordion",
				icon: "at-move-line-arrows-up-down",
				statusBadges: ["javascript"],
			},
			{
				title: "Action list",
				path: "action-list",
				rootPath: "/components/action-list",
				componentPath: "components/ActionList",
				icon: "at-multiple-arrows-up v-flip",
				statusBadges: ["javascript", "deprecated"],
				deprecated: true,
			},
			{
				title: "Alerts",
				path: "alerts",
				rootPath: "/components/alerts",
				componentPath: "components/Alerts",
				icon: "at-info-circle",
				statusBadges: ["javascript"],
			},
			{
				title: "Badges",
				path: "badge",
				rootPath: "/components/badge",
				componentPath: "components/Badge",
				icon: "at-star-badge-award",
			},
			{
				title: "Breadcrumb",
				path: "breadcrumb",
				rootPath: "/components/breadcrumb",
				componentPath: "components/Breadcrumb",
				icon: "at-dots-horizontal",
			},
			{
				title: "Buttons",
				path: "buttons",
				rootPath: "/components/buttons",
				componentPath: "components/Buttons",
				icon: "at-click",
				statusBadges: ["updated"],
			},
			{
				title: "Cards",
				path: "cards",
				rootPath: "/components/cards",
				componentPath: "components/Card",
				icon: "at-square-mirror",
				statusBadges: ["updated"],
			},
			{
				title: "Charts",
				path: "charts",
				rootPath: "/components/charts",
				componentPath: "components/Charts",
				icon: "at-pie-chart",
				statusBadges: ["javascript", "deprecated"],
				deprecated: true,
			},
			{
				title: "Checkbox",
				path: "checkbox",
				rootPath: "/components/checkbox",
				componentPath: "components/Checkbox",
				icon: "at-check-clipboard",
				statusBadges: ["updated"],
			},
			{
				title: "Datepickers",
				path: "datepickers",
				rootPath: "/components/datepickers",
				componentPath: "components/Datepickers",
				icon: "at-calendar-date",
				statusBadges: ["javascript", "updated"],
			},
			{
				title: "Dialog",
				path: "dialog",
				rootPath: "/components/dialog",
				componentPath: "components/Dialog",
				icon: "at-message-text",
				statusBadges: ["javascript", "updated"],
			},
			{
				title: "Dropdown",
				path: "dropdown",
				rootPath: "/components/dropdown",
				componentPath: "components/Dropdown",
				icon: "at-list-folder",
				statusBadges: ["javascript", "updated"],
			},
			{
				title: "Expandable",
				path: "expandable",
				rootPath: "/components/expandable",
				componentPath: "components/Expandable",
				icon: "at-move-line-arrows-up-down",
				statusBadges: ["javascript", "updated"],
			},
			{
				title: "Input field",
				path: "input-field",
				rootPath: "/components/input-field",
				componentPath: "components/InputField",
				icon: "at-pencil-edit",
				statusBadges: ["javascript", "updated"],
			},
			{
				title: "Links",
				path: "links",
				rootPath: "/components/links",
				componentPath: "components/Links",
				icon: "at-link-chain",
			},
			{
				title: "Lists",
				path: "lists",
				rootPath: "/components/lists",
				componentPath: "components/Lists",
				icon: "at-list",
			},
			{
				title: "Loader",
				path: "loader",
				rootPath: "/components/loader",
				componentPath: "components/Loader",
				icon: "at-arrows-dots-rotate",
			},
			{
				title: "Media Object",
				path: "media-object",
				rootPath: "/components/media-object",
				componentPath: "components/MediaObject",
				icon: "at-image",
			},
			{
				title: "Navigation",
				path: "nav",
				rootPath: "/components/nav",
				componentPath: "components/Nav",
				icon: "at-compass-pointers",
				statusBadges: ["javascript", "deprecated"],
				deprecated: true,
			},
			{
				title: "Pagination",
				path: "pagination",
				rootPath: "/components/pagination",
				componentPath: "components/Pagination",
				icon: "at-text-direction-left",
				statusBadges: ["javascript"],
			},
			{
				title: "Panel",
				path: "panel",
				rootPath: "/components/panel",
				componentPath: "components/Panel",
				icon: "at-down-orientation",
			},
			{
				title: "Progress steps",
				path: "progress-steps",
				rootPath: "/components/progress-steps",
				componentPath: "components/ProgressSteps",
				icon: "at-circle-arrow-right",
			},
			{
				title: "Radio button",
				path: "radio-button",
				rootPath: "/components/radio-button",
				componentPath: "components/RadioButton",
				icon: "at-check-circle",
				statusBadges: ["javascript", "updated"],
			},
			{
				title: "Rangeslider",
				path: "rangeslider",
				rootPath: "/components/rangeslider",
				componentPath: "components/Rangeslider",
				icon: "at-horizontal-sliders-dots",
				statusBadges: ["javascript", "updated"],
			},
			{
				title: "Sheet",
				path: "sheet",
				rootPath: "/components/sheet",
				componentPath: "components/Sheet",
				icon: "at-toilet-paper",
				statusBadges: ["javascript"],
			},
			{
				title: "Select",
				path: "select",
				rootPath: "/components/select",
				componentPath: "components/Select",
				icon: "at-arrow-down-circle",
				statusBadges: ["updated"],
			},
			{
				title: "Sidebar",
				path: "sidebar",
				rootPath: "/components/sidebar",
				componentPath: "components/Sidebar",
				icon: "at-layout-vertical",
				statusBadges: ["javascript"],
			},
			{
				title: "Skip link",
				path: "skip-link",
				rootPath: "/components/skip-link",
				componentPath: "components/SkipLink",
				icon: "at-next",
			},
			{
				title: "Slab",
				path: "slab",
				rootPath: "/components/slab",
				componentPath: "components/Slab",
				icon: "at-comment-blank",
			},
			{
				title: "Status",
				path: "status",
				rootPath: "/components/status",
				componentPath: "components/Status",
				icon: "at-triangle-exclamation",
			},
			{
				title: "Tables",
				path: "tables",
				rootPath: "/components/tables",
				componentPath: "components/Tables",
				icon: "at-tables",
			},
			{
				title: "Tabs",
				path: "tabs",
				rootPath: "/components/tabs",
				componentPath: "components/Tabs",
				icon: "at-folders",
				statusBadges: ["javascript"],
			},
			{
				title: "Tags",
				path: "tags",
				rootPath: "/components/tags",
				componentPath: "components/CodeTags",
				icon: "at-electricity-square",
			},
			{
				title: "Toast",
				path: "toast",
				rootPath: "/components/toast",
				componentPath: "components/Toast",
				icon: "at-info-message",
				statusBadges: ["javascript"],
			},
			{
				title: "Togglebox",
				path: "togglebox",
				rootPath: "/components/togglebox",
				componentPath: "components/Togglebox",
				icon: "at-movement-arrows-left-right",
				statusBadges: ["updated"],
			},
			{
				title: "Tooltips",
				path: "tooltips",
				rootPath: "/components/tooltips",
				componentPath: "components/Tooltips",
				icon: "at-list-message",
				statusBadges: ["javascript"],
			},
			{
				title: "Topbar",
				path: "topbar",
				rootPath: "/components/topbar",
				componentPath: "components/Topbar",
				icon: "at-website",
				statusBadges: ["javascript", "updated"],
			},
			{
				title: "Topbar Migrating to v2",
				path: "topbar-migrating-to-v2",
				rootPath: "/components/TopbarMigratingToV2",
				componentPath: "components/TopbarMigratingToV2",
				icon: "at-exclamation-website",
				statusBadges: ["javascript", "new"],
			},
		],
	},
];
